import { composeIO } from 'react-compose-io'
import { popoverFiltroClassificacoesIO } from './PopoverFiltroClassificacoes.IO'
import { PopoverFiltroClassificacoesView } from './PopoverFiltroClassificacoes.View'

export const PopoverFiltroClassificacoes = composeIO(PopoverFiltroClassificacoesView, popoverFiltroClassificacoesIO)
